import color from "color";
import Button from "components/Button/Button";
import Icon from "components/Icon/Icon";
import styled from "styled-components";

export const ServicesSection = styled.section`
  &:not(:last-of-type) {
    border-bottom: none;
  }
`;

export const ArrowIcon = styled(Icon)`
  &&& {
    transform: rotate(180deg) translateX(5px);
    height: 12px;
    width: 12px;
    min-width: 12px;
    margin: 0 0 0 5px;
    transition: transform 0.2s, height 0.2s, width 0.2s;
  }

  button:hover > &&& {
    height: 14px;
    width: 14px;
    min-width: 14px;
    transform: rotate(180deg) translateX(8px);
  }
`;

export const Status = styled.span`
  font-size: 12px;
  margin-right: 5px;
  white-space: nowrap;
  color: ${(props) => props.theme.black50};

  &:first-letter {
    text-transform: capitalize;
  }
`;

export const ParcelButton = styled(Button)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${(props) => props.theme.black};
  padding: 12px 7px 12px 12px;
  margin: 2px 0;
  width: 100%;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${(props) => props.theme.subtleHover};
    color: ${(props) => props.theme.black};
    border-radius: 7px;
    font-weight: 500;
  }


  & > div {
    min-width: 16px;
    display: flex;
    align-items: center;
    gap: 10px;
    text-align: left;
    width: 100%;
    margin-right: 5px;
  }

  &:nth-child(2) {
    display: none;
  }

  .icon {
    height: 24px;
    width: 24px;
    min-width: 24px;
  }
`;

export const HelpIcon = styled(Icon)`
  background-color: ${(props) => props.theme.grey};
  height: 12px;
  width: 12px;
  min-width: 12px;
`;

export const ReturnButton = styled(ParcelButton)`
  color: ${(props) => props.theme.red};
  width: auto;
  padding-right: 0;

  &:hover {
    background-color: ${(props) => props.theme.subtleHover};
    color: ${(props) => props.theme.red};
    border-radius: 7px;
  }

  .icon {
    background-color: ${(props) => props.theme.red};
  }
`;

export const ReturnSection = styled.div`
  display: none;
  align-items: center;
`;

export const ReturnTooltip = styled.span`
  display: block;
  text-align: left;
  max-width: 200px;
  color: ${({ theme }) => color(theme.black).alpha(0.75).hex()};

  a {
    white-space: nowrap;
    margin-right: 5px;
    color: ${({ theme }) => theme.black};
  }
`;

export const RemoveButton = styled.div`
  color: ${({ theme }) => theme.red};
  & > i {
    background-color: ${({ theme }) => theme.red};
  }
`;
